module.exports = "https://www.gc-pro.gnp.com.mx/bfe69f4757b9332390466d37ed7e008d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-add-small.png
// module id = 8117
// module chunks = 0